<template>
  <div  id="app" class="" style="width:100vw" @click="bodyclick">
    <Navbar
      :mode="scrollTop > 0 ? 'navbar-light bg-light' : ''"
      style="z-index:1071; "
      @click="navClick"
    />
    <router-view @click="bodyclick2"></router-view>
    <Contact  />
  </div>
</template>

<script>
import Navbar from "./components/navbar";
import Contact from "./components/contact";

import Sticky from "sticky-js";
export default {
  components: {
    Contact,
    Navbar,
  },
  name: "App",
  data() {
    return {
      viewenable:false,
      scrollTop: 0,
    };
  },
  methods: {
    navClick(){
      console.log('navClick')
      this.$store.state.bodyClick=false;
    },
    bodyclick(){
      console.log(this.$store.state.navEnable)
      console.log('bodyclick')
      this.$store.state.bodyClick=true;
    },
    bodyclick2(){
      console.log('bodyclick2')
    },
    getTop() {
      return document.documentElement.scrollTop;
    },
    handleScroll(e) {
      this.scrollTop =
        e.target.documentElement.scrollTop || e.target.body.scrollTop; // 执行代码
      this.$store
        .dispatch(
          "updateTop",
          this.scrollTop > e.target.documentElement.clientHeight / 3
            ? true
            : false
        )
        .catch((err) => {
          console.error(err);
        });
      this.$store
        .dispatch("updateNav", this.scrollTop > 0 ? true : false)
        .catch((err) => {
          console.error(err);
        });
    },
    getProductCategorys() {
      this.$store.dispatch("getProductCategorys").catch((err) => {
        console.error(err);
      });
    },
    getLang(){
      this.$store.dispatch("getLang").catch((err) => {
        console.error(err);
      });
    },
    initLan(){
     if(localStorage.getItem('lan')) {
       this.$store.state.lan=localStorage.getItem('lan')
     }else{
       localStorage.setItem('lan','zh')
       this.$store.state.lan='zh'
     }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.getLang();
    this.getProductCategorys();
    // setTimeout(function(){
    //   _this.viewenable=true;
    // },1000)

var sticky = new Sticky(".sticky");
sticky.update();
  },
  created() {
    window.vm = this;
    this.initLan();
  },
};
</script>

<style>
.unselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /* -webkit-user-select: none;
cursor: default;
pointer-events: none; */
}

</style>
